import { Button, Calendar, Col, Row } from 'components';
import { useOutsideClick } from 'core';
import { subMonths } from 'date-fns';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: absolute;
  padding: 20px;
  background-color: #fff;
  border-radius: 20px;
  top: 160px;
  margin-left: 200px;

  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);

  ${(props) =>
    props.isChart &&
    `
    top: 20px;
    right: 20px;
    z-index: 2;
    margin-left: 0;
  `}
`;

const PickerModal = ({
  handleClose,
  handleFilterChange,
  setSelectedOption,
  paymentHistory,
  isChart
}) => {
  const now = new Date(),
    [startDate, setStartDate] = useState(subMonths(now, 0)),
    [endDate, setEndDate] = useState(now),
    wrapperRef = useRef(null),
    { t } = useTranslation();

  useOutsideClick(wrapperRef, handleClose, ['date-picker', 'react-datepicker']);

  function handleSelect(opt) {
    const [start, end] = opt;

    setStartDate(start);
    setEndDate(end);
  }

  function handleConfirm() {
    setSelectedOption && setSelectedOption(4);
    handleFilterChange([startDate, endDate], 4);
    handleClose();
  }

  return (
    <Wrapper ref={wrapperRef} className="date-picker" isChart={isChart}>
      <Col>
        <Calendar
          isChart={isChart}
          onChange={handleSelect}
          startDate={startDate}
          endDate={endDate}
          maxDate={now}
          selectsRange
        />

        <Row between wid="100%" marg="10px 0 0" gap="8px" className="date-picker">
          <Button text={t('common.confirm')} className="date-picker" onClick={handleConfirm} />

          <Button
            text={t('common.cancel')}
            className="date-picker"
            bordered
            onClick={handleClose}
          />
        </Row>
      </Col>
    </Wrapper>
  );
};

export default PickerModal;
